import { UserOutlined, WechatOutlined } from '@ant-design/icons';
import { Layout, Tabs } from 'antd';
import { memo, useMemo } from 'react';
import ConversationTab from './ConversationTab';
import UserTab from './UserTab';

const { Sider } = Layout;

const SiderLayout = () => {
  const tabItems = useMemo(
    () => [
      {
        label: (
          <span>
            <WechatOutlined />
            <strong>Conversations</strong>
          </span>
        ),
        key: 'Conversations',
        children: <ConversationTab />,
      },
      {
        label: (
          <span>
            <UserOutlined />
            <strong>Users</strong>
          </span>
        ),
        key: 'Users',
        children: <UserTab />,
      },
    ],
    []
  );

  return (
    <Sider
      id="scrollableDiv"
      width={325}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
      }}
    >
      <Tabs items={tabItems} size="small" centered />
    </Sider>
  );
};

export default memo(SiderLayout);
